import { Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class FilterClearService {
  readonly clearRequests = signal(0)

  clearFilters() {
    this.clearRequests.update(requests => requests + 1)
  }
}
